export { RichText, type RichTextProps } from './RichText';
